import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FAQList } from './FAQList';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * StateFAQSection - State-specific FAQs for state pages with styled cards
 */
export const StateFAQSection = ({ 
  stateName,
  stateCode,
  limit = 5
}) => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        // Fetch formation-related FAQs that apply to all states
        const response = await axios.get(`${API}/public/faq-items`, {
          params: { 
            category: 'formation',
            limit: limit
          }
        });
        setFaqs(response.data.items || []);
      } catch (error) {
        console.error('Error fetching state FAQs:', error);
      } finally {
        setLoading(false);
      }
    };

    if (stateName) {
      fetchFAQs();
    }
  }, [stateName, limit]);

  if (loading) {
    return (
      <section className="mt-12 pt-8 border-t border-gray-200" data-testid="state-faq-loading">
        <div className="animate-pulse space-y-4">
          <div className="h-7 bg-gray-200 rounded w-80"></div>
          <div className="space-y-2">
            {[1, 2, 3].map(i => (
              <div key={i} className="h-14 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (faqs.length === 0) {
    return null;
  }

  return (
    <section className="mt-12 pt-8 border-t border-gray-200" data-testid="state-faq-section">
      <h2 className="text-xl font-semibold text-gray-900 mb-6">
        Common Questions about {stateName} LLC Formation
      </h2>
      
      <FAQList items={faqs} showRelatedInModal={true} maxRelated={4} />
      
      <div className="mt-6">
        <Link
          to="/faq"
          className="inline-flex items-center gap-2 text-amber-600 hover:text-amber-700 text-sm font-medium transition-colors group"
          data-testid="state-faq-view-all"
        >
          View all FAQs
          <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </section>
  );
};

export default StateFAQSection;
